import React from 'react';
import { Col } from '../../../ui';

export const HandlerColBig: React.FC = ({ children }) => {
  return <Col xs={12}>{children}</Col>;
};
